import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import dynamic from "next/dynamic";
import Image from "next/image";
import { healerServices } from "@/services/healerServices";
import styles from "@/styles/Testimonial.module.css";
const OwlCarousel = dynamic(() => import("react-owl-carousel"), {
  ssr: false,
});

const Testimonial = () => {
  const [testimonials, setTestimonial] = useState([]);

  useEffect(() => {
    fetchHealerTestimonials();
  }, []);

  const fetchHealerTestimonials = async () => {
    try {
      const res = await healerServices.getHealerTestimonial();
      if (res.status) {
        setTestimonial(res.data);
      } else {
        toast.error(res.message, {
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error("Error fetching healers:", error);
    }
  };

  return (
    <>
      {testimonials && testimonials.length > 0 ? (
        <div>
          <section className={styles["testimonial-section"]}>
            <Container>
              <Row>
                <Col lg={12} className="m-auto">
                  <div className="section-title">
                    <h1 className="title">
                      Healers Speak: Their Journey With Zenkify
                    </h1>
                  </div>
                </Col>
                <Col lg={12}>
                  <OwlCarousel
                    className={styles["testimonial-slider"] + " " + "owl-theme"}
                    loop={false}
                    margin={10}
                    nav={false}
                    dots={true}
                    autoplay={true}
                    responsive={{
                      0: {
                        items: 1,
                      },
                      600: {
                        items: 3,
                      },
                      1000: {
                        items: 4,
                      },
                    }}
                  >
                    {testimonials && testimonials.length > 0 ? (
                      testimonials.map((testimonial) => (
                        <div className="item" key={testimonial.id}>
                          <div className={styles["testimonial-card"]}>
                            <span>
                              <i className="fa-solid fa-quote-right"></i>
                            </span>
                            <div className={styles["testimonial-header"]}>
                              {/* <div className={styles["user-image"]}>
                                <Image height={330} width={310} src= "/images/user-1.png"  alt="Jina Nilson" />
                              </div> */}
                              <div className={styles["user-name"]}>
                                <h4>{testimonial?.healer?.first_name}</h4>
                                {/* <h6>Reiki Expert</h6> */}
                              </div>
                            </div>
                            <p>{testimonial?.review}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No testimonials available.</p>
                    )}
                  </OwlCarousel>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      ) : null}
    </>
  );
};

export default Testimonial;
